import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';

@Component({
    name: 'CmgTermsAndConditionsModal',
})
export default class CmgTermsAndConditionsModal extends Vue {
    get isMobile(): boolean {
        return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
    }

    get visible(): boolean {
        return this.$appStore.state.ui.modals.rewardTermsAndConditions.visible;
    }

    get termsAndConditions(): string {
        const modalArgs = this.$appStore.state.ui.modals.rewardTermsAndConditions.args;
        return (modalArgs && modalArgs.termsAndConditions) || 'N/A';
    }

    get chevronLeftUrl(): string {
        return this.$appStore.state.cms.images.icons.chevronLeft.default;
    }

    get onBack() {
        const modalArgs = this.$appStore.state.ui.modals.rewardTermsAndConditions.args;
        return modalArgs?.onBack;
    }

    onClose() {
        this.$services.ui.setModalVisibility('rewardTermsAndConditions', false);
        this.$services.ui.focusBack();
    }
}
